const brandValues = [
  {
    char: "紅",
    title: "熱血與連結",
    desc: "無論是親子間的血緣溫情，還是聯誼中萌芽的悸動，「紅」代表我們對生活的熱忱與溫暖。",
    color: "bg-red-50",
    textColor: "text-red-600",
    borderColor: "border-red-200",
  },
  {
    char: "歡",
    title: "快樂的承諾",
    desc: "從露營的星空到比賽的喝采，歡笑是我們唯一的語言。我們對快樂的承諾，從未改變。",
    color: "bg-orange-50",
    textColor: "text-orange-600",
    borderColor: "border-orange-200",
  },
  {
    char: "密",
    title: "深度與探索",
    desc: "每一場讀書會的思辨、每一齣劇本殺的推演，我們帶領參與者揭開生活中的神祕驚喜。",
    color: "bg-amber-50",
    textColor: "text-amber-600",
    borderColor: "border-amber-200",
  },
];

export default function AboutUs() {
  return (
    <section id="about-us" className="py-20 md:py-28 bg-stone-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Brand Story */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Image */}
          <div className="relative">
            <div className="rounded-2xl overflow-hidden" style={{ height: "480px" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/aad57f6d25ac647840afcbbf8c5e8703.jpg"
                alt="關於娛樂紅歡密"
                className="w-full h-full object-cover object-top"
              />
            </div>
            {/* Floating card */}
            <div className="absolute -bottom-6 -right-4 md:-right-8 bg-white rounded-2xl p-5 border border-stone-100 max-w-xs">
              <div className="flex items-center gap-3 mb-2">
                <img
                  src="https://public.readdy.ai/ai/img_res/2de05ae8-ab7f-40ca-afb5-96f93dc606a2.png"
                  alt="Rappy me Logo"
                  className="w-10 h-10 object-contain"
                />
                <div>
                  <p className="font-bold text-gray-900 text-sm">娛樂紅歡密</p>
                  <p className="text-gray-400 text-xs">Red Joy Mystery</p>
                </div>
              </div>
              <p className="text-gray-600 text-xs leading-relaxed">
                「我們不只是在辦活動，我們是在創造人與人之間最真誠的摩擦力。」
              </p>
            </div>
          </div>

          {/* Right: Content */}
          <div>
            <p className="text-red-600 text-sm font-semibold tracking-widest uppercase mb-3">
              About Us
            </p>
            <h2
              className="text-3xl md:text-5xl font-black text-gray-900 mb-6"
              style={{ fontFamily: "'Noto Serif TC', serif" }}
            >
              我們不只是
              <br />
              活動的策劃者
              <br />
              <span className="text-red-600">更是回憶的編織者</span>
            </h2>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              在這個數位化的時代，人與人之間的距離看似很近，心卻往往很遠。「娛樂紅歡密」的誕生，是源於一個簡單的初心：我們相信，真正的快樂來自於實體的連結。
              <br /><br />
              從一場靜心的課程到一場瘋狂的烤肉派對，「娛樂紅歡密」陪你定義生活，把平凡的日子，辦成一場場不平凡的盛事。
            </p>

            {/* Brand Values */}
            <div className="flex flex-col gap-3">
              {brandValues.map((val) => (
                <div
                  key={val.char}
                  className={`flex items-start gap-4 p-4 rounded-xl border ${val.borderColor} ${val.color}`}
                >
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg bg-white font-black text-xl ${val.textColor} shrink-0`}>
                    {val.char}
                  </div>
                  <div>
                    <p className={`font-bold text-sm ${val.textColor} mb-0.5`}>{val.title}</p>
                    <p className="text-gray-600 text-sm leading-relaxed">{val.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}
